import { createSlice } from '@reduxjs/toolkit';
import ReducerConstants from '../../../../_shared/constants/reducers';
import initialState from './initialState';

const layout = createSlice({
  name: ReducerConstants.LAYOUT,
  initialState,
  reducers: {
    updateListVariant(state, action) {
      return {
        ...state,
        listVariant: action.payload
      };
    },
    updateShowFilters(state, action) {
      return {
        ...state,
        showFilters: action.payload
      };
    },
    updateShowChat(state, action) {
      return {
        ...state,
        showChat: action.payload
      };
    }
  }
});

export default layout;
